import SettingsPanel from './SettingsPanel';

export default SettingsPanel;
